import { render, staticRenderFns } from "./FantasyPast.vue?vue&type=template&id=78414188&"
import script from "./FantasyPast.vue?vue&type=script&lang=js&"
export * from "./FantasyPast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports